import React from 'react';
import { Box, Typography } from '@mui/material';

import { v2Colors } from '../../design/theme';
import { PRODUCT_DETAIL_STATIC_TAGS } from './productDetailHelpers';

const DISPLAY_FONT = '"Foregen", "Roboto Slab", Georgia, serif';

function FeatureTag({ label }) {
  return (
    <Box
      sx={{
        px: 1.25,
        py: 0.5,
        borderRadius: 5,
        bgcolor: v2Colors.selectedFill,
        color: v2Colors.primary,
        fontSize: '0.65rem',
        fontWeight: 600,
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
      }}
    >
      <Box
        component="span"
        sx={{
          width: 5,
          height: 5,
          borderRadius: '50%',
          bgcolor: v2Colors.primary,
        }}
      />
      {label}
    </Box>
  );
}

export default function ProductDetailInfo({ name, aka, attributeLine, subCategory }) {
  const tags = [
    ...(subCategory ? [String(subCategory).trim()] : []),
    ...PRODUCT_DETAIL_STATIC_TAGS,
  ];

  return (
    <Box sx={{ mb: 2.5 }}>
      <Typography
        component="h1"
        sx={{
          fontWeight: 700,
          fontSize: { xs: '1.65rem', sm: '1.85rem' },
          lineHeight: 1.2,
          color: v2Colors.heading,
          mb: aka ? 0.5 : 1,
          md: {
            fontFamily: DISPLAY_FONT,
            fontSize: '1.65rem',
            letterSpacing: '-0.02em',
          },
        }}
      >
        {name}
      </Typography>
      {aka ? (
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: '0.95rem',
            color: v2Colors.primary,
            mb: 1,
            md: {
              fontFamily: DISPLAY_FONT,
              fontSize: '0.9rem',
            },
          }}
        >
          aka {aka}
        </Typography>
      ) : null}
      {attributeLine ? (
        <Typography
          sx={{
            fontSize: '0.9rem',
            color: v2Colors.heading,
            fontWeight: 500,
            mb: tags.length ? 1.25 : 0,
            lineHeight: 1.45,
            md: {
              fontSize: '0.82rem',
              color: v2Colors.textMuted,
            },
          }}
        >
          {attributeLine}
        </Typography>
      ) : null}
      {tags.length ? (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
          {tags.map((label) => (
            <FeatureTag key={label} label={label} />
          ))}
        </Box>
      ) : null}
    </Box>
  );
}
